import React from "react"
import * as s from "./CompetitionPrizes.module.scss"

export const CompetitionPrizes = ({ data }) => {
  const { prizes } = data

  return (
    <div className={s.wrapper___isInViewport}>
      <div className={s.prizes}>
        {prizes.map((prize, i) => {
          return (
            <div
              key={i}
              className={s.prize}
              style={{ backgroundColor: prize.backgroundColor }}
            >
              {prize.icon && (
                <div
                  className={s.prizeIcon}
                  style={{ backgroundImage: `url(${prize.icon.sourceUrl})` }}
                />
              )}
              <span>{prize.blurb}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
